import type { SearchRequest } from "@elastic/elasticsearch/lib/api/types";
import type { UscAccessoryType, UscPackType } from "../../utils/accessoryUtils";

export const USC_ACCESSORIES_INIT = "uscAccessories/init";
type UscAccessoriesInit = {
    type: typeof USC_ACCESSORIES_INIT;
    accessories: UscAccessoryType[];
    packs: UscPackType[];
    esQuery: SearchRequest;
};
export const initUscAccessories = (
    accessories: UscAccessoryType[],
    packs: UscPackType[],
    esQuery: SearchRequest,
): UscAccessoriesInit => ({
    type: USC_ACCESSORIES_INIT,
    accessories,
    packs,
    esQuery,
});

export const USC_ACCESSORIES_SET_FAILED = "uscAccessories/setFailed";
type UscAccessoriesSetFailed = { type: typeof USC_ACCESSORIES_SET_FAILED; failed: boolean };
export const setUscAccessoriesFailed = (failed: boolean): UscAccessoriesSetFailed => ({
    type: USC_ACCESSORIES_SET_FAILED,
    failed,
});

export type UscAccessoriesTypes = UscAccessoriesInit | UscAccessoriesSetFailed;
